/* eslint-disable no-unused-expressions */

import React from 'react';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import clsx from 'clsx';
import { useReactToPrint } from 'react-to-print';

const printIcon = '/-/media/Project/FAB2/shared/images/printer.svg';
const pdfIcon = '/-/media/Project/FAB2/shared/images/pdf.svg';
const excelIcon = '/-/media/Project/FAB2/shared/images/excel.svg';

export const ExportsComponent = ({ componentRef, data = {}, t }) => {
  const excelListener = () => {
    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const ws = XLSX?.utils?.json_to_sheet(data);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const dataRes = new Blob([excelBuffer], { type: fileType });
    FileSaver?.saveAs(dataRes, 'Indicative_Amortisation_Schedule' + fileExtension);
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef?.current,
  });

  return (
    <div className="prints-container">
      <OverlayTrigger
        placement={'bottom'}
        overlay={
          <Tooltip className={clsx('custom-tooltip max-opacity', 'downward', 'darkMode', 'center')}>
            {t('exportPrintTooltip')}
          </Tooltip>
        }
      >
        <div onClick={handlePrint} role="button" className="print-action">
          <img src={printIcon} alt="print" />
        </div>
      </OverlayTrigger>
      <OverlayTrigger
        placement={'bottom'}
        overlay={
          <Tooltip className={clsx('custom-tooltip max-opacity', 'downward', 'darkMode', 'center')}>
            {t('exportPdfTooltip')}
          </Tooltip>
        }
      >
        <div onClick={handlePrint} role="button" className="print-action">
          <img src={pdfIcon} alt="pdf" />
        </div>
      </OverlayTrigger>
      <OverlayTrigger
        placement={'bottom'}
        overlay={
          <Tooltip className={clsx('custom-tooltip max-opacity', 'downward', 'darkMode', 'center')}>
            {t('exportExcelTooltip')}
          </Tooltip>
        }
      >
        <div role="button" onClick={excelListener} className="print-action">
          <img src={excelIcon} alt="excel" />
        </div>
      </OverlayTrigger>
    </div>
  );
};
